const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-rejected",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c0,7.727 -6.273,14 -14,14c-7.727,0 -14,-6.273 -14,-14c0,-7.727 6.273,-14 14,-14Zm0,2.197c6.514,0 11.803,5.289 11.803,11.803c-0,6.514 -5.289,11.803 -11.803,11.803c-6.514,-0 -11.803,-5.289 -11.803,-11.803c0,-6.514 5.289,-11.803 11.803,-11.803Z",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.962,9.962c-0.188,0.187 -0.294,0.442 -0.294,0.708c-0,0.266 0.106,0.521 0.294,0.708c-0,0 3.648,3.647 3.648,3.647l-3.648,3.647c-0.188,0.187 -0.294,0.442 -0.294,0.708c0,0.549 0.452,1.002 1.002,1.002c0.265,-0 0.52,-0.106 0.708,-0.294l3.647,-3.648l3.647,3.648c0.187,0.188 0.442,0.294 0.708,0.294c0.549,-0 1.002,-0.453 1.002,-1.002c-0,-0.266 -0.106,-0.521 -0.294,-0.708l-3.648,-3.647l3.648,-3.647c0.188,-0.188 0.294,-0.443 0.294,-0.708c-0,-0.55 -0.453,-1.002 -1.002,-1.002c-0.266,0 -0.521,0.106 -0.708,0.294l-3.647,3.648c-0,-0 -3.647,-3.648 -3.647,-3.648c-0.187,-0.188 -0.442,-0.294 -0.708,-0.294c-0.266,-0 -0.521,0.106 -0.708,0.294l-0,-0Z",
    style: {
      fill: "#d30000",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressRejected);
export default __webpack_public_path__ + "static/media/iconR-progress-rejected.e7a77c9d5d6c3a6b4b85c53e303d4d07.svg";
export { ForwardRef as ReactComponent };